"use client";

import { useEffect } from "react";
import { GTMManager } from "@/lib/GTMManager";

// GA4 measurement id and Google Ads tag id. Hardcoded defaults preserve the
// previous behavior; both can be overridden per-environment via env vars.
const GA4_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || "G-TBDYKLBN2Q";
const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID || "AW-11483263783";

export default function GTMInit() {
    useEffect(() => {
        GTMManager.getInstance().init(GA4_MEASUREMENT_ID, GOOGLE_ADS_ID);
    }, []);

    return null;
}
